exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tips[data-v-010f83d5] {\n  background-color: #3b3b62;\n  text-align: center;\n  font-size: 18px;\n  color: #ffffff;\n  margin-bottom: 20px;\n}\n.tips p[data-v-010f83d5] {\n  padding: 5px 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-010f83d5","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/college/tjkExam.vue
// module id = 1173
// module chunks = 0